export const projectsData = [
  {
    id: 1,
    projectName: 'AI Social Media Auto-Reply System',
    projectDesc: 'An LLM-powered automation system for context-aware social media responses. The system classifies incoming messages, generates contextually relevant replies using a large language model, and executes automated response workflows — reducing manual intervention in social media engagement operations.',
    capabilities: [
      'LLM integration for response generation',
      'Message classification and intent detection',
      'Contextual reply generation',
      'Automated workflow execution',
      'Structured response pipeline',
    ],
    tags: ['Node.js', 'Python', 'LLM', 'AI Workflow', 'Automation'],
    code: '',
    demo: '',
  },
  {
    id: 2,
    projectName: 'AI Image Scanner & Content Extractor',
    projectDesc: 'An OCR-based pipeline for extracting structured data from unstructured image input. The system processes images, applies optical character recognition, and transforms extracted raw content into structured, queryable data — enabling downstream automation and data workflows.',
    capabilities: [
      'Optical Character Recognition (OCR)',
      'Image analysis and preprocessing',
      'Content extraction from unstructured input',
      'Structured data transformation',
      'Pipeline integration for downstream workflows',
    ],
    tags: ['Python', 'OCR', 'Image Processing', 'Data Extraction', 'AI Pipeline'],
    code: '',
    demo: '',
  },
]
